import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Progress } from 'reactstrap';
import FontAwesome from 'react-fontawesome';


class ProgressBar extends Component {

    static getDerivedStateFromProps(nextProps, prevState) {
        if(nextProps.percent !== prevState.percent) {
            return { percent: nextProps.percent };
        }
        return null;
    }

    constructor(props) {
        super(props);

        this.state = {
            percent: 0,
        };
    }

    render() {
        const percent = Math.min(100, Math.ceil(this.state.percent));
        if(this.state.percent > 0 || this.props.alwaysShowBar) {
            return (
                <Progress
                    animated
                    color="primary"
                    value={Math.max(this.state.percent, 0)}
                    className="my-2"
                >
                    {this.props.hideValue ? null : `${percent}%`}
                </Progress>
            );
        }
        return <div className="my-2 text-center text-primary"><FontAwesome name="spinner" spin size="2x" /></div>;
    }
}


ProgressBar.propTypes = {
    percent: PropTypes.number,
    alwaysShowBar: PropTypes.bool,
    hideValue: PropTypes.bool,
};

export default ProgressBar;
